import CodiceFiscale from "codice-fiscale-js";

export const generateFiscalCode = ({ placeOfBirth, dateOfBirth, gender, name, surname }) => {
    try {
        if (!placeOfBirth || !dateOfBirth) {
            return null;
        }
        let dateArray = dateOfBirth.split('/');
        if (dateArray.length !== 3) {
            return null;
        }
        dateArray = dateArray.map(d => parseInt(d, 10));

        for (let d of dateArray) {
            if (!d) {
                return null;
            }
        }

        const user = new CodiceFiscale({
            name: name,
            surname: surname,
            gender: gender ? 'M' : 'F',
            day: dateArray[0],
            month: dateArray[1],
            year: dateArray[2],
            birthplace: placeOfBirth,
        });

        return user;
    } catch (error) {
        return null;
    }
}